import { render, staticRenderFns } from "./AcceptBlock.vue?vue&type=template&id=09929ab8&scoped=true&"
import script from "./AcceptBlock.vue?vue&type=script&lang=js&"
export * from "./AcceptBlock.vue?vue&type=script&lang=js&"
import style0 from "./AcceptBlock.vue?vue&type=style&index=0&id=09929ab8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09929ab8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09929ab8')) {
      api.createRecord('09929ab8', component.options)
    } else {
      api.reload('09929ab8', component.options)
    }
    module.hot.accept("./AcceptBlock.vue?vue&type=template&id=09929ab8&scoped=true&", function () {
      api.rerender('09929ab8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/proposal/proposal-renderer/AcceptBlock.vue"
export default component.exports